<template>
  <div class="mine_right flex_item">
    <div class="mine_rightTop">
      <div class="flex">
        <span class="mine_line"></span>
        <p>发票信息</p>
        <span v-if="isEditing" class="flex_item mine_rightTopWarn">请认真填写</span>
        <span v-if="!isEditing" class="flex_item"></span>
        <button v-if="!isEditing" class="bj_btn" @click="isEditing = true">编辑</button>
        <button v-if="isEditing" class="bj_btn" @click="saveReceiptInfo">保存</button>
      </div>
    </div>
    <div class="mine_rightBody fp">
      <div class="flex mine_rightLi">
        <label class="flex">发票抬头</label>
        <p v-if="!isEditing" class="mine_rightVal">{{infoMsgFormat(receiptInfo.billName)}}</p>
        <input v-if="isEditing" type="text" v-model=receiptInfo.billName class="mine_rightIpt">
      </div>
      <div class="flex mine_rightLi">
        <label class="flex">单位税号</label>
        <p v-if="!isEditing" class="mine_rightVal">{{infoMsgFormat(receiptInfo.taxCode)}}</p>
        <input v-if="isEditing" type="text" v-model=receiptInfo.taxCode class="mine_rightIpt">
      </div>
      <div class="flex mine_rightLi">
        <label>注册地址</label>
        <p v-if="!isEditing" class="mine_rightVal">{{infoMsgFormat(receiptInfo.billAddress)}}</p>
        <input v-if="isEditing" type="text" v-model=receiptInfo.billAddress class="mine_rightIpt">
      </div>
      <div class="flex mine_rightLi">
        <label>注册电话</label>
        <p v-if="!isEditing" class="mine_rightVal">{{infoMsgFormat(receiptInfo.billPhone)}}</p>
        <input v-if="isEditing" type="text" v-model=receiptInfo.billPhone class="mine_rightIpt">
      </div>
      <div class="flex mine_rightLi">
        <label>开户银行</label>
        <p v-if="!isEditing" class="mine_rightVal">{{infoMsgFormat(receiptInfo.bank)}}</p>
        <input v-if="isEditing" type="text" v-model=receiptInfo.bank class="mine_rightIpt">
      </div>
      <div class="flex mine_rightLi">
        <label>银行账号</label>
        <p v-if="!isEditing" class="mine_rightVal">{{infoMsgFormat(receiptInfo.bankAccount)}}</p>
        <input v-if="isEditing" type="text" v-model=receiptInfo.bankAccount class="mine_rightIpt">
      </div>
      <div class="flex mine_rightLi">
        <label>收件姓名</label>
        <p v-if="!isEditing" class="mine_rightVal">{{infoMsgFormat(receiptInfo.collectName)}}</p>
        <input v-if="isEditing" type="text" v-model=receiptInfo.collectName class="mine_rightIpt">
      </div>
      <div class="flex mine_rightLi">
        <label>收件电话</label>
        <p v-if="!isEditing" class="mine_rightVal">{{infoMsgFormat(receiptInfo.collectPhone)}}</p>
        <input v-if="isEditing" type="text" v-model=receiptInfo.collectPhone class="mine_rightIpt">
      </div>
      <div class="flex mine_rightLi">
        <label>收件地址</label>
        <p v-if="!isEditing" class="mine_rightVal">{{infoMsgFormat(receiptInfo.collectAddress)}}</p>
        <input v-if="isEditing" type="text" v-model=receiptInfo.collectAddress class="mine_rightIpt">
      </div>
      <div class="flex mine_rightLi">
        <label>收件邮箱</label>
        <p v-if="!isEditing" class="mine_rightVal">{{infoMsgFormat(receiptInfo.collectEmail)}}</p>
        <input v-if="isEditing" type="text" v-model=receiptInfo.collectEmail class="mine_rightIpt">
      </div>
    </div>
  </div>
</template>

<script>
import { getReceiptInfo, updateReceiptInfo } from '../../server/user_center_receipt';

export default {
  data() {
    return {
      isEditing: false,
      receiptInfo: {
        billName: "", // 发票抬头
        taxCode: "", // 单位税号
        billAddress: "", // 注册地址
        billPhone: "", // 注册电话
        bank: "", // 开户银行
        bankAccount: "", // 银行账号
        collectName: "", // 收件姓名
        collectPhone: "", // 收件电话
        collectAddress: "", // 收件地址
        collectEmail: "", // 收件邮箱
      }
    }
  },
  mounted() {
    this.fetchReceiptInfo();
  },
  methods: {
    async saveReceiptInfo() {
      this.isEditing = false;
      let result = await updateReceiptInfo(this.receiptInfo);
      if (result != false) {
        alert('修改成功');
      }
    },
    async fetchReceiptInfo() {
      let result = await getReceiptInfo();
      if (result != false) {
        this.receiptInfo = result;
      }
    },
    infoMsgFormat(text) {
      if (text == "" || text == null) {
        return "- -";
      }
      return text;
    }
  },
}
</script>

<style scoped>
.mine_right {
  box-sizing: border-box;
  margin-top: 16px;
}

.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.flex_item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}

.mine_rightTop {
  padding: 24px 32px;
  border-bottom: 1px solid #F3F3F3;
  background-color: #fff;
}

.mine_rightTop p {
  font-size: 28px;
  font-weight: 600;
  color: #222;
}

.mine_line {
  width: 5px;
  height: 28px;
  background-color: #003399;
  border-radius: 3px;
  margin-right: 20px;
}

.mine_rightTopWarn {
  color: #FF4343;
  margin-left: 16px;
  font-size: 16px;
}

.fp .mine_rightIpt {
  padding: 10px 16px;
  border: 0;
  outline: 0;
  background-color: transparent;
  border: 1px solid #eff3f2;
  width: 400px;
  box-sizing: border-box;
  position: relative;
}

.mine_rightLi {
  margin-top: 34px;
}

.mine_rightLi label {
  font-size: 14px;
  color: #222;
  line-height: 20px;
  font-weight: 400;
  text-align: right;
  margin-right: 42px;
  width: 100px;
  justify-content: end;
}

.mine_rightLi label font:first-child {
  padding-right: 5px;
  display: none;
}

.bj_btn {
  font-size: 16px;
  font-weight: 400;
  color: #003399;
  background-color: white;
  padding: 7px 20px;
  border: 1px solid #003399;
  border-radius: 4px;
}

.mine_rightBody {
  padding: 16px 32px 80px 32px;
  background-color: #fff;
}

.mine_rightVal {
  font-size: 14px;
  color: #222;
  font-weight: 400;
  text-align: left;
  line-height: 20px;
}
</style>